import { jsx as _jsx } from "react/jsx-runtime";
import { initConsent } from '@/lib/consent';
import '@/lib/i18n';
import { queryClient } from '@/lib/queryClient';
import { initSentry } from '@/lib/sentry';
import { installViewportKeyProvenance } from '@/lib/shortcuts/viewportKeyGuard';
import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
initSentry();
// After Sentry: consent decides whether Session Replay is added to it.
initConsent();
// Must run before any viewer mounts, and outside the React tree so StrictMode's
// double-invoke cannot double-register it. Records which keydowns Cornerstone
// blanket-cancelled, so viewer shortcuts can tell that apart from a dialog or
// slider genuinely claiming the key. See viewportKeyGuard.ts.
installViewportKeyProvenance();
createRoot(document.getElementById('root')).render(_jsx(StrictMode, { children: _jsx(QueryClientProvider, { client: queryClient, children: _jsx(App, {}) }) }));
